import { InjectionToken } from '@angular/core';
import { DatasourceType } from '@selfai-platform/pipeline-common';

export const KE_AVALIABLE_DATASOURCES = new InjectionToken<DatasourceType[]>('AvaliableDatasources', {
  factory: (): DatasourceType[] => [
    'externalFile',
    'googleSpreadsheet',
    'hdfs',
    'jdbc',
    'kafka',
    'libraryFile',
    's3',
    'hive',
  ],
});
